export default "__VITE_ASSET__BOQGUcMP__"